import React from 'react'
import maintainance_img from "../../../src/assets/images/all/under maintenance.svg";


const Maintenance = () => {
  return (
    <div className="maintenance_page">
        <h2 style={{ marginTop: "3rem" }}>Under Maintenance</h2>
        <img src={maintainance_img} alt="" />
    </div>
  )
}

export default Maintenance
